import { OfficialDocument } from '@/shared/types/entities/OfficialDocument';
import { ResultPublicationDocument } from '@/shared/types/entities/ResultPublicationDocument';
import { School } from '@/shared/types/entities/School';
import { Status } from '@/shared/types/entities/Status';
import { User } from '@/shared/types/entities/User';
import { InjectionKey } from '@vue/composition-api';
import Vue from 'vue';
import Vuex from 'vuex';

import { ActionContext, Store } from 'vuex';
import { authActions } from './actions/auth';
import { documentActions } from './actions/document';
import { schoolActions } from './actions/school';
import { authMutations } from './mutations/auth';
import { documentMutations } from './mutations/document';
import { schoolMutations } from './mutations/school';
import { notificationMutations } from './mutations/notification';
import { titleMutations } from './mutations/title';
import { Notification } from '@/shared/types/vuetify/snackbar';
import { AdminSchool } from '@/shared/types/entities/AdminSchool';
import { Validation } from '@/shared/types/entities/MasterData';
import { masterDataMutations } from './mutations/masterData';

export type State = {
  validation: Validation;
  title: {
    /** タイトルアイコン(表示アイコン) */
    icon: string;

    /** メインタイトル(表示タイトル) */
    main: string;
  };
  notification: Notification;
  auth: {
    token: string | undefined;
    user: User | undefined;
  };
  school: {
    listSchools: {
      schools: School[];
      total: number;
    };
    adminListSchools: {
      adminSchools: AdminSchool[];
      total: number;
    };
    listStatus: {
      statuses: Status[];
      total: number;
    };
  };
  document: {
    officialDocument: OfficialDocument;
    resultPublicationDocument: ResultPublicationDocument;
  };

  /** エラーメッセージ(共通エラーメッセージ表示画面用) */
  errorMessage: '';
};

const initialDocument = {
  name: '',
  url: '',
  pdfUrl: '',
  startAt: '',
  endAt: '',
  updatedAt: '',
  updatedBy: '',
};

const state: State = {
  validation: {
    password_length_min: 0,
    password_length_max: 0,
    passing_file_mimetype: '',
    notification_file_mimetype: '',
    google_analytics_url: '',
  },
  title: {
    icon: '',
    main: '',
  },
  notification: {
    isShow: false,
    type: 'success',
    message: '',
  },
  auth: {
    token: undefined,
    user: undefined,
  },
  school: {
    listSchools: {
      schools: [] as School[],
      total: 0,
    },
    adminListSchools: {
      adminSchools: [] as AdminSchool[],
      total: 0,
    },
    listStatus: {
      statuses: [] as Status[],
      total: 0,
    },
  },
  document: {
    officialDocument: { ...initialDocument },
    resultPublicationDocument: { ...initialDocument },
  },
  errorMessage: '',
};

export type ActionType = ActionContext<State, State>;

Vue.use(Vuex);

export const key: InjectionKey<Store<State>> = Symbol();

export const store = new Vuex.Store({
  state,
  getters: {
    validation: (state) => state.validation,
    notification: (state) => state.notification,
    user: (state) => state.auth.user,
    schools: (state) => state.school.listSchools.schools,
    schoolsTotal: (state) => state.school.listSchools.total,
    statuses: (state) => state.school.listStatus.statuses,
    statusesTotal: (state) => state.school.listStatus.total,
    officialDocument: (state) => state.document.officialDocument,
    resultDocument: (state) => state.document.resultPublicationDocument,
  },
  actions: {
    ...authActions,
    ...schoolActions,
    ...documentActions,
  },
  mutations: {
    ...masterDataMutations,
    ...authMutations,
    ...titleMutations,
    ...schoolMutations,
    ...documentMutations,
    ...notificationMutations,
  },
});

export const useStore = (): Store<State> => {
  return store;
};
